/* eslint-disable no-unused-vars */
import dayjs, { Dayjs } from 'dayjs'
import {
  DAYS_OF_WEEK,
  EVENT_TYPES,
  FORMAT_DATETIME,
  HOUR_OF_DAY,
  TIME_FORMAT
} from '../constants'
import { getIconforEvent } from '../icons'
import { getIconforEvent as getIconforEventV2 } from '../iconsV2'
import { EventType, IEvent, INorm, INormOfWeek } from '../types'
import isoWeek from 'dayjs/plugin/isoWeek';
dayjs.extend(isoWeek);

export const customDateFormat = (value: Dayjs | Date, formatStr: string) =>
  dayjs(value).format(formatStr)

export const extractMonthYear = (value: Dayjs | Date) => {
  const date = dayjs(value);
  return {
    month: date.format('MMMM'),
    year: date.year(),
  };
};

export const extractWeek = (value: Dayjs | Date) => {
  const date = dayjs(value);
  const startOfWeek = date.startOf('isoWeek');
  const endOfWeek = date.endOf('isoWeek');

  return {
    startDateDisplay: startOfWeek.format('D MMMM'),
    endDateDisplay: endOfWeek.format('D MMMM'),
    year: endOfWeek.year(),
  };
};

export const convertType: Record<EventType, string> = {
  [EVENT_TYPES.TEACHING]: 'info',
  [EVENT_TYPES.BUSY]: 'error',
  [EVENT_TYPES.HOLIDAY]: 'warning',
  [EVENT_TYPES.OTHER]: 'success',
  [EVENT_TYPES.LIVE_ONLINE]: 'purple',
  [EVENT_TYPES.INACTIVE]: 'inactive',
}

export const convertTypeDisable: Record<EventType, string> = {
  [EVENT_TYPES.TEACHING]: 'infoDisable',
  [EVENT_TYPES.BUSY]: 'errorDisable',
  [EVENT_TYPES.HOLIDAY]: 'warning',
  [EVENT_TYPES.OTHER]: 'success',
  [EVENT_TYPES.LIVE_ONLINE]: 'purple',
  [EVENT_TYPES.INACTIVE]: 'inactive'
}

export const daysOfWeekKeys = Object.values(DAYS_OF_WEEK)

export const calculateNormOfWeek = (
  norms: INorm[],
  events: IEvent[],
  startDate: Dayjs,
  endDate: Dayjs
): INormOfWeek => {
  const norm = norms.find(
    (norm) =>
      startDate.isBetween(norm.startDate, norm.endDate, 'day', '[]') &&
      endDate.isBetween(norm.startDate, norm.endDate, 'day', '[]')
  )

  if (!norm) {
    return {
      normOfWeek: 0,
      totalNorm: 0
    }
  }

  const normsOfWeek = events.filter(
    (event) =>
      dayjs(event.startDate).isBetween(startDate, endDate, 'day', '[]') &&
      endDate.isBetween(startDate, endDate, 'day', '[]') &&
      event.type === EVENT_TYPES.TEACHING
  )

  return {
    normOfWeek: normsOfWeek.length,
    totalNorm: norm.maxShift,
    status: norm.status
  }
}

export const splitEventsIntoDays = (events: IEvent[]) => {
  const splittedEvents: IEvent[] = []

  for (const event of events) {
    const startDate = dayjs(event.startDate)
    const endDate = dayjs(event.endDate)
    const isSameDay = startDate.isSame(endDate, 'day')

    if (isSameDay) {
      splittedEvents.push(event)
      continue
    }

    // Start day
    // splittedEvents.push({
    //   ...event,
    //   startDate: startDate.toDate(),
    //   endDate: startDate.endOf('day').toDate()
    // })

    // All-day events for intermediate days
    let currentDate = startDate.startOf('day')

    while (currentDate.isBefore(endDate, 'day')) {
      splittedEvents.push({
        ...event,
        startDate: currentDate.startOf('day').toDate(),
        endDate: currentDate.endOf('day').toDate()
      })
      currentDate = currentDate.add(1, 'day')
    }

    // End day
    splittedEvents.push({
      ...event,
      startDate: endDate.startOf('day').toDate(),
      endDate: endDate.toDate()
    })
  }

  return splittedEvents
}

export const checkIsAllday = (startDate: Dayjs, endDate: Dayjs) => {
  if (!startDate.isValid() || !endDate.isValid()) {
    return false
  }

  return (
    startDate.format(TIME_FORMAT) ===
      startDate.startOf('day').format(TIME_FORMAT) &&
    endDate.format(TIME_FORMAT) === endDate.endOf('day').format(TIME_FORMAT) &&
    startDate.isBefore(endDate)
  )
}

export const hoursOfDayKeys = Object.values(HOUR_OF_DAY)

export const isDisplayIcon = (event: IEvent) => {
  const iconList = getIconforEvent(event, event.isActive)
  if (event.source === 'LMS') {
    return Array.isArray(iconList) && iconList.length > 0
  }
  return !!iconList
}

export const isDisplayIconV2 = (event: IEvent) => {
  const iconList = getIconforEventV2(event)
  if (event.source === 'LMS') {
    return Array.isArray(iconList) && iconList.length > 0
  }
  return !!iconList
}

export const getActToken = (): string => {
  return localStorage.getItem('actToken') || ''
}

export const getRefreshToken = (): string => {
  return localStorage.getItem('refreshToken') || ''
}

export const setActToken = (accToken: string) => {
  localStorage.setItem('actToken', accToken)
}

export const setRefreshToken = (refreshToken: string) => {
  localStorage.setItem('refreshToken', refreshToken)
}
/**
 * @description Thay thế các biến trong 1 message bằng các giá trị tương ứng
 * @param {string} str
 * @param {Record<string, any>} replacements
 * @return {*}
 * @memberof QueryHelper
 */
export const replaceMessage = (str: string, replacements: Record<string, any>): string => {
  return str.replace(/{(\w+)}/g, (_, key) => {
    if (key === 'DATE_MESSAGE' && replacements['TYPE'] === 'DATE') {
      const value = String(replacements['DATE_MESSAGE']).split(',')
      let dates: string[] = []
      value.forEach((item: string) => {
        dates.push(dayjs(item).format(FORMAT_DATETIME))
      })
      return dates.join(', ')
    }
    return replacements[key] || `{${key}}`
  })
}
